import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// reducer import
import accountReducer from './accountReducer';
import customizationReducer from './customizationReducer';
import snackbarReducer from './snackbarReducer';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    account: persistReducer(
        {
            key: 'account',
            storage,
            keyPrefix: 'berry-'
        },
        accountReducer
    ),
    customization: customizationReducer,
    snackbar: snackbarReducer
});

export default reducer;
